export function canReviewEntityGovernanceForRole(
  role: string | null | undefined
) {
  const normalizedRole = String(role || "").toLowerCase();
  return ["super_admin", "superadmin"].includes(normalizedRole);
}
